var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow62(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2335_35615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0092 45.0051L35.8972 27.1934H24.1211L30.0092 45.0051Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.009 45.0051L24.1209 27.1934H15.8691L30.009 45.0051Z",
    fill: "#FC6D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8704 27.1934L14.0812 32.6063C14.0016 32.8469 14.0016 33.1061 14.0811 33.3468C14.1607 33.5874 14.3157 33.7971 14.5239 33.9459L30.0103 45.0052L15.8703 27.1935L15.8704 27.1934Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8691 27.1937H24.1209L20.5748 16.4657C20.3923 15.9137 19.5978 15.9138 19.4154 16.4657L15.8691 27.1937Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0099 45.0051L35.8979 27.1934H44.1498L30.0099 45.0051Z",
    fill: "#FC6D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1496 27.1934L45.9389 32.6063C46.0184 32.8469 46.0184 33.1062 45.9389 33.3468C45.8593 33.5875 45.7043 33.7972 45.496 33.9459L30.0098 45.0052L44.1496 27.1935V27.1934Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1484 27.1937H35.8965L39.4427 16.4657C39.6252 15.9137 40.4197 15.9138 40.6021 16.4657L44.1484 27.1937Z",
    fill: "#E24329"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2335_35615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 29,
    fill: "white",
    transform: "translate(14 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow62);
export default __webpack_public_path__ + "static/media/row-6-2.6e4ce7f1616c0f301bae398965613332.svg";
export { ForwardRef as ReactComponent };